module.exports = __webpack_public_path__ + "static/media/bg_auto.621b90ea.png";